import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface CancelServiceordreResult {
  confirm: boolean;
  note?: string;
}

export interface CancelServiceordreData {
  serviceordreNo: number;
}

@Component({
  selector: 'app-cancel-serviceordre',
  templateUrl: './cancel-serviceordre.component.html',
  styleUrls: ['./cancel-serviceordre.component.scss'],
})
export class CancelServiceordreComponent implements OnInit {
  form: UntypedFormGroup;

  get canConfirm(): boolean {
    return this.noteControl!.valid;
  }

  get noteControl() {
    return this.form.get('note');
  }

  constructor(
    private builder: UntypedFormBuilder,
    private dialogRef: MatDialogRef<CancelServiceordreComponent>,
    @Inject(MAT_DIALOG_DATA) public data: CancelServiceordreData
  ) {
    this.form = builder.group({
      note: ['', [Validators.required, Validators.minLength(3)]],
    });
  }

  ngOnInit(): void {}

  annuller() {
    const result: CancelServiceordreResult = {
      confirm: true,
      note: this.noteControl!.value,
    };
    this.dialogRef.close(result);
  }
}
